import * as React from 'react';
import { BlIcon } from 'shared-react';
import './NotificationBar.scss';

export interface NotificationBarProps {
  notificationText: string;
  dismissText: string;
  onDismiss: () => void;
}

class NotificationBar extends React.Component<NotificationBarProps, {}> {
  render() {
    const { onDismiss, dismissText, notificationText } = this.props;
    return (
      <div className="NotificationBar">
        <span className="NoticationBar-text">{notificationText}</span>
        <button
          className="NotificationBar-dismissButton"
          data-it="NotificationBar-dismiss"
          type="button"
          onClick={e => onDismiss()}
        >
          <span>{dismissText}</span>
          <span className="NotificationBar-iconWrapper">
            <BlIcon icon="remove" size="xs" />
          </span>
        </button>
      </div>
    );
  }
}

export default NotificationBar;
